import React, { Fragment } from 'react';
import PropTypes           from 'prop-types';
import ReactTooltip        from 'react-tooltip';
import { withTranslation } from 'react-i18next';
import AmountFormat        from '../AmountFormat';
import TextInput           from '../TextInput';
import Datepicker          from '../Datepicker';
import './styles.scss';
import CbuFormat from "../CbuFormat";


/**
 * Created by Feedback Software on 25/10/18.
 * @param t
 * @param name
 * @param placeholder
 * @param value
 * @param onChange function to handle the state in the father component
 * @param onBlur function to handle the state in the father component
 * @param type
 * @param helpText
 * @param label if empty doesn't show
 * @param disabled boolean to disable input
 * @param fieldClasses array of classes for the field
 * @param inputClasses array of classes for the input
 * @param controlClasses array of classes for the control
 * @param icon font awesome class of icon to display
 * @param iconPosition can receive 'is-left' or 'is-right' to position as class
 * @param min minimal amount used when the input is number
 * @param step incremental amount
 * @param labelClasses
 * @param information
 * @param typeElement
 * @param disabledNullSelect
 * @param optionsSelect
 * @param displayTypeAmount
 * @param currency
 * @param allowNegative
 * @param maxDate
 * @param minDate
 * @param maxDetail
 * @param showMonthYearPicker
 * @param showTimeSelect
 * @param dateFormat
 * @returns {*}
 * @constructor
 */
const FormElement = ({
                       t,
                       name,
                       placeholder,
                       value,
                       onChange,
                       onBlur,
                       type,
                       helpText,
                       disabled,
                       fieldClasses,
                       inputClasses,
                       controlClasses,
                       icon,
                       iconPosition,
                       min,
                       step,
                       labelClasses,
                       label,
                       information,
                       typeElement,
                       disabledNullSelect,
                       optionsSelect,
                       displayTypeAmount,
                       currency,
                       allowNegative,
                       maxDate,
                       minDate,
                       maxDetail,
                       showMonthYearPicker,
                       showTimeSelect,
                       dateFormat,
                       validateField,
                         helper,
                     }) => (
  <Fragment>
    <div>
      <div className="fields">
        <div className="field-label is-normal">
          <label
            className={`label ${labelClasses}`}
            htmlFor={name}
          >
            <span>
              {label}
              {information && (
                <i
                  className="ml-8px fas fa-info-circle has-text-warning"
                  aria-hidden="true"
                  data-for={`tooltip-${labelClasses}`}
                  data-tip="Test"
                >
                  <ReactTooltip
                    id={`tooltip-${labelClasses}`}
                    type="warning"
                    effect="solid"
                  >
                    {information}
                  </ReactTooltip>
                </i>
              )
              }
            </span>
          </label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className={`custom-field column ${fieldClasses}`}>
              <div className={`control ${controlClasses}`}>
                {typeElement === 'input' && (
                  <>
                    <input
                      className={`input ${inputClasses}`}
                      name={name}
                      id={name}
                      placeholder={placeholder}
                      value={value}
                      onChange={onChange}
                      onBlur={onBlur}
                      type={type}
                      disabled={disabled}
                      min={min}
                      step={step}
                      maxLength="144"
                    />
                    {helpText &&
                    <p className="help has-text-danger">{helpText}</p>}
                  </>
                )}
                {typeElement === 'amountFormat' && (
                  <AmountFormat
                    customInput={TextInput}
                    displayType={displayTypeAmount}
                    prefix={`${currency} `}
                    value={value}
                    allowNegative={allowNegative}
                    name={name}
                    label={label}
                    onChange={onChange}
                    onBlur={onBlur}
                    controlclasses={controlClasses}
                    inputclasses={inputClasses}
                    fieldClasses={fieldClasses}
                    disabled={disabled}
                  />
                )}
                {typeElement === 'datepicker' && (
                  <Datepicker
                    onChange={onChange}
                    selected={value}
                    placeholderText={placeholder}
                    maxDate={maxDate}
                    minDate={minDate}
                    maxDetail={maxDetail}
                    showMonthYearPicker={showMonthYearPicker}
                    showTimeSelect={showTimeSelect}
                    dateFormat={dateFormat}
                  />
                )}
                {typeElement === 'select' && (
                  <select
                    name={name}
                    className={`input ${inputClasses}`}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                  >
                    {!disabledNullSelect
                    && (
                      <option value="">
                        {placeholder}
                      </option>
                    )
                    }
                    {optionsSelect && optionsSelect.map((option, key) => (
                      <option
                        key={option.value || option.id || key}
                        value={option.value || option.id || key}
                        disabled={option.disabled}
                      >
                        {option.text || option.name || option.document_type ||
                          option.bank_name || t(option.nameTranslate) || option}
                      </option>
                    ))
                    }
                  </select>
                )}
                {typeElement === 'text' && (
                  <div className="text-description">{value}</div>
                )}
                {
                  !!icon && (
                    <span className={`icon ${iconPosition}`}>
                      <i className={`fa ${icon}`} />
                    </span>
                  )
                }
                  {typeElement === 'cbuFormat' && (
                      <CbuFormat
                          name={name}
                          value={value}
                          label={label}
                          onChange={onChange}
                          validateField={ validateField }
                          controlClasses={controlClasses}
                          fieldClasses={fieldClasses}
                          helper={ helper }
                          helpText={helpText}
                          disabled={disabled}

                      />
                  )}
              </div>
              <p className="help has-text-danger">{helpText}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Fragment>
);

FormElement.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  helpText: PropTypes.string,
  currency: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  disabledNullSelect: PropTypes.bool,
  allowNegative: PropTypes.bool,
  fieldClasses: PropTypes.string,
  inputClasses: PropTypes.string,
  controlClasses: PropTypes.string,
  labelClasses: PropTypes.string,
  information: PropTypes.string,
  typeElement: PropTypes.string,
  displayTypeAmount: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  dateFormat: PropTypes.string,
  optionsSelect: PropTypes.arrayOf(PropTypes.object),
  min: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  step: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  maxDetail: PropTypes.string,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  showMonthYearPicker: PropTypes.bool,
  showTimeSelect: PropTypes.bool,
  validateField: PropTypes.func,
    helper: PropTypes.string,
};

FormElement.defaultProps = {
  placeholder: null,
  value: undefined,
  type: 'text',
  onChange: () => {
  },
  onBlur: () => {
  },
  helpText: null,
  label: null,
  disabled: false,
  disabledNullSelect: false,
  fieldClasses: '',
  inputClasses: '',
  controlClasses: '',
  labelClasses: '',
  information: '',
  currency: '',
  typeElement: 'input',
  icon: null,
  iconPosition: null,
  min: null,
  step: null,
  optionsSelect: [],
  allowNegative: false,
  displayTypeAmount: '',
  maxDate: new Date(),
  minDate: null,
  maxDetail: 'year',
  dateFormat: 'dd/MM/yyyy',
  showTimeSelect: false,
  showMonthYearPicker: false,
  validateField: () => {},
    helper:'',
};
export default withTranslation()(FormElement);
